import apiUrl from '@/common/apiUrl'
import webApiUtil from "@/common/webApiUtil";

export default {
  namespaced: true,
  state: {
    dataAllList: {
      totalRows: 0,
      list: []
    }
  },
  mutations: {
    setResultDataList: (state, data) => {
      state.dataAllList.list = data.dataList
      state.dataAllList.totalRows = data.dataList ? data.dataList.length : 0
    }
  },
  getters: {},
  actions: {
    createNotif: async ({rootState}, _params = {}) => {
      try {
        rootState.isLoading = true
        const url = apiUrl.noticeCreate
        const res = await webApiUtil.post(url, _params)

        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          return 'success'
        } else {
          return null
        }
      } catch (e) {
        return null
      } finally {
        rootState.isLoading = false
      }
    },
  }
}
